var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserHoveredIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.441,
    height: 29.441,
    viewBox: "0 0 29.441 29.441",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "user-alt-solid",
    d: "M14.72,16.56A8.28,8.28,0,1,0,6.44,8.28,8.282,8.282,0,0,0,14.72,16.56Zm7.36,1.84H18.912a10.01,10.01,0,0,1-8.384,0H7.36A7.36,7.36,0,0,0,0,25.761v.92a2.761,2.761,0,0,0,2.76,2.76H26.681a2.761,2.761,0,0,0,2.76-2.76v-.92A7.36,7.36,0,0,0,22.081,18.4Z",
    fill: "#0d3b66"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserHoveredIcon);
export default __webpack_public_path__ + "static/media/user-hovered-icon.d911768484168e5b403d66076c0135bb.svg";
export { ForwardRef as ReactComponent };